<div class="layout-column custom-panel full-width full-height">
  <div class="padding-5" *ngFor="let column of tableFilterColumns"
       [ngClass]="{'switch-active': column.isActive}">
    <bringoz-switch [classSize]="'sm'"
                    [checked]="column.isActive"
                    [label]="column.label"
                    [name]="column.field"
                    (onChange)="toggleColumnFilter(column)">
    </bringoz-switch>
  </div>
</div>
